module.exports = __webpack_public_path__ + "img/icon_zip.34fa5ea9.png";